import { PersonOutline } from "@mui/icons-material";
import { Avatar, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import LinkCard, { getInitials } from "./LinkCard";

export default function OwnerCard({ owner }) {
  const { t } = useTranslation();
  const name = owner.deleted ? t("DeletedUser") : owner.name;

  return (
    <LinkCard
      icon={<PersonOutline color="primary" />}
      title={t("Owner")}
      to={owner.to}
      testId="appointment.details.user-chip"
    >
      <Avatar sx={{ width: 36, height: 36, bgcolor: "primary.main" }}>
        <Typography variant="body2" fontWeight={600}>
          {getInitials(name)}
        </Typography>
      </Avatar>
      <Typography variant="body1" fontWeight={600} noWrap>
        {name}
      </Typography>
    </LinkCard>
  );
}
